<template>
  <svg
    v-if="icon == 'Account'"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    xlink:href="#account-a"
  >
    <g fill="currentColor" fill-rule="nonzero" id="account-a">
      <path
        d="M6 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM12 9v6h-2v-4H2v4H0V9z"
      />
    </g>
  </svg>

  <svg
    v-else-if="icon == 'Article'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#article-a"
  >
    <path
      id="article-a"
      d="M4.41 12.652v7.7c0 .94-.764 1.706-1.705 1.706-.94 0-1.705-.765-1.705-1.705v-7.701h3.41zM23 2v17.798a2.263 2.263 0 01-2.26 2.26H4.84a2.72 2.72 0 00.6-1.705V2H23zm-3.39 13.602H8.789a.514.514 0 100 1.029h10.82a.514.514 0 100-1.029zm0-4.114H8.789a.514.514 0 100 1.028h10.82a.514.514 0 100-1.028zm-5.143-4.63H8.789a.514.514 0 100 1.03h5.678a.514.514 0 100-1.03z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Attendance'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#attendance-a"
  >
    <path
      id="attendance-a"
      d="M23.084 24H.738c.062-1.363.552-2.515 1.638-3.25 1.036-.7 2.205-1.21 3.329-1.776.647-.326 1.346-.553 1.977-.905 1.438-.803 1.89-2.853 1.034-4.277-.635-1.057-1.28-2.123-1.752-3.255-.222-.533-.051-1.232-.048-1.856.002-.32.042-.639.04-.958-.008-1.52-.291-3.096.022-4.545C7.567.452 11.902-.937 14.18.707c.213.153.411.39.647.44 1.963.414 2.544 2.384 2.398 4.302-.058.76-.247 1.51-.379 2.265-.02.113-.105.246-.07.332 1.027 2.53-1.134 4.069-1.9 6.03-.487 1.249-.045 3.303 1.154 3.927 1.354.705 2.798 1.233 4.17 1.908 1.646.81 2.722 2.07 2.883 4.089"
    />
  </svg>

  <svg
    v-else-if="icon == 'Audio'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#audio-a"
  >
    <path
      id="audio-a"
      d="M14.266 0c.325.366.717.774 1.072 1.212 2.288 2.822 3.587 6.038 3.828 9.672.01.14.048.278.072.417v1.402c-.078.655-.137 1.313-.24 1.963-.577 3.638-2.19 6.749-4.73 9.334l-2.06-2.063c2.648-2.7 4.075-6.024 4.07-9.919-.005-3.883-1.44-7.195-4.081-9.951L14.266 0zm-3.797 3.636c4.597 4.313 4.748 12.192.054 16.696l-2.01-2.03c3.488-3.562 3.332-9.229.039-12.592l1.917-2.074zM6.842 7.378c2.6 2.413 2.6 6.894-.019 9.323L4.8 14.671c1.466-1.578 1.37-3.846.017-5.252l2.025-2.04z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Audio 2'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M13 3v18l-5.27-5.295H1.999v-7.41l5.997-.001L13 3Zm2-1c4.057 1.336 7 5.308 7 10s-2.943 8.664-7 10v-2.226c2.932-1.243 5-4.256 5-7.774s-2.068-6.53-5-7.774V2Zm0 3.98c1.813 1.325 3 3.528 3 6.02 0 2.492-1.187 4.695-3 6.02V5.98Z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Ball'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      id="ball-a"
      d="M12.085 0C18.75.06 24.06 5.478 23.999 12.158 23.94 18.693 18.506 24.047 11.981 24 5.289 23.95-.054 18.558 0 11.908.054 5.282 5.474-.058 12.084 0zm3.091 2.112c.073.427.136.803.202 1.178.078.446.038.488-.397.55-.973.14-1.935.32-2.816.795a.396.396 0 01-.322.003c-.899-.478-1.877-.666-2.87-.803-.381-.053-.43-.118-.36-.512.071-.39.135-.78.208-1.21-2.195.734-3.915 2.014-5.283 3.878.503.082.95.158 1.4.226.43.065.477.134.395.554-.186.966-.344 1.933-.191 2.924.016.107-.062.251-.137.344-.191.235-.44.428-.604.678-.388.587-.745 1.195-1.104 1.8-.14.236-.233.281-.471.153-.22-.118-.435-.246-.652-.37l-.536-.3c-.188 1.67.984 5.206 1.99 6.058l.252-.534c.083-.178.163-.358.25-.534.145-.294.234-.316.52-.17.907.464 1.828.89 2.855 1.026.09.012.207.088.245.166.453.915 1.154 1.626 1.876 2.322.287.277.29.344.015.624-.286.292-.568.588-.876.907 2.164.693 4.307.696 6.465 0-.3-.312-.573-.604-.855-.888-.294-.295-.293-.364-.003-.643.722-.695 1.424-1.406 1.874-2.322a.366.366 0 01.246-.166c1.008-.137 1.917-.543 2.807-1.004.348-.18.417-.163.59.198l.503 1.058c1.317-1.848 1.972-3.845 1.993-6.113-.407.23-.761.433-1.117.633-.347.195-.416.17-.599-.175-.468-.886-.96-1.754-1.716-2.44a.363.363 0 01-.102-.28c.164-.999.005-1.975-.186-2.95-.083-.424-.036-.49.395-.556.453-.07.904-.147 1.402-.228-1.367-1.867-3.092-3.144-5.286-3.877zm-2.88 6.157c1.115.805 2.233 1.605 3.35 2.405.194.139.245.306.169.535-.427 1.286-.85 2.574-1.267 3.863-.085.26-.248.363-.519.359-.679-.01-1.357-.003-2.036-.003v.001c-.67 0-1.34-.007-2.01.004-.287.005-.447-.12-.533-.384a592.43 592.43 0 00-1.256-3.838c-.082-.244-.014-.41.186-.552a875.58 875.58 0 003.33-2.389c.202-.146.384-.147.586 0z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Basket'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="nonzero"
    xlink:href="#basket-a"
  >
    <path
      id="basket-a"
      d="M12 0a5.002 5.002 0 014.9 4h3.995l2.222 20H.883L3.105 4H7.1A5.002 5.002 0 0112 0zm5 8a1 1 0 01-2 0V6H9v2a1 1 0 01-.883.993L8 9a1 1 0 01-1-1V6H4.895L3.117 22h17.766L19.105 6H17zm-5-6a3.001 3.001 0 00-2.83 2h5.66A3.001 3.001 0 0012 2z"
    />
    <g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z" /></g>
  </svg>


  <svg 
    v-else-if="icon == 'Blue Sky'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_2835_2017)">
        <path
            d="M5.02894 3.375C7.68878 5.37184 10.5497 9.4206 11.6001 11.5934C12.6506 9.42076 15.5114 5.3718 18.1713 3.375C20.0905 1.93416 23.2001 0.819323 23.2001 4.3668C23.2001 5.07528 22.7939 10.3184 22.5557 11.1696C21.7276 14.129 18.7099 14.8838 16.0257 14.4269C20.7177 15.2255 21.9113 17.8706 19.3336 20.5157C14.438 25.5393 12.2972 19.2553 11.7484 17.6451C11.6478 17.3499 11.6008 17.2118 11.6001 17.3292C11.5994 17.2118 11.5523 17.3499 11.4518 17.6451C10.9032 19.2553 8.76244 25.5395 3.86656 20.5157C1.2888 17.8706 2.48236 15.2253 7.17444 14.4269C4.49012 14.8838 1.47244 14.129 0.64444 11.1696C0.406192 10.3183 0 5.0752 0 4.3668C0 0.819323 3.10968 1.93416 5.0288 3.375H5.02894Z"
            />
    </g>
    <defs>
        <clipPath id="clip0_2835_2017">
            <rect width="24" height="24" fill="white" />
        </clipPath>
    </defs>
</svg>





  <svg
    v-else-if="icon == 'Burger'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#burger-a"
  >
    <path id="burger-a" d="M24 18v3H0v-3h24zm0-7v3H0v-3h24zm0-7v3H0V4h24z" />
  </svg>

  <svg
    v-else-if="icon == 'Calendar'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xlink:href="#calendar-a"
  >
    <path
      id="calendar-a"
      fill="currentColor"
      d="M10.992 18.28l-3.117-3.118a.374.374 0 0 1 0-.55l1.283-1.306c.16-.16.39-.16.55 0l1.559 1.559 3.002-3.025c.16-.16.39-.16.55 0l1.306 1.306c.16.16.16.39 0 .55l-4.583 4.583c-.16.16-.39.16-.55 0zM19.31 3.153c1.971 0 3.575 1.604 3.575 3.552v12.169a3.58 3.58 0 0 1-3.575 3.575H4.667c-1.948 0-3.552-1.604-3.552-3.575V6.706a3.57 3.57 0 0 1 3.552-3.552h.848v1.123c0 1.031.825 1.856 1.856 1.856a1.849 1.849 0 0 0 1.856-1.856V3.154h5.523v1.123c0 1.031.825 1.856 1.856 1.856a1.849 1.849 0 0 0 1.856-1.856V3.154h.848zm1.72 15.721v-9.19H2.97v9.19c0 .962.757 1.719 1.697 1.719H19.31c.963 0 1.72-.78 1.72-1.719zM7.37 5.194c-.503 0-.916-.413-.939-.94V2.031a.93.93 0 0 1 .94-.94c.527 0 .94.436.94.94v2.223c0 .527-.436.94-.94.94zm9.26 0a.93.93 0 0 1-.94-.94V2.031a.93.93 0 0 1 .94-.94c.526 0 .939.436.939.94v2.223c0 .527-.436.94-.94.94z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Calendar 2'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <defs>
      <path
        id="Calendar2-a"
        d="M11 11v11H3c-.5 0-1-.5-1-1V11h9Zm11 0v10c0 .5-.5 1-1 1h-8V11h9Zm-4.368 2.32c-.704 0-1.235.197-1.592.592-.357.395-.55.907-.576 1.536-.004.1-.006.244-.007.434v.63c.001.187.003.328.007.424.032.64.223 1.157.572 1.552.35.395.881.592 1.596.592.715 0 1.247-.197 1.596-.592.35-.395.54-.912.572-1.552.01-.288.016-.533.016-.736 0-.203-.005-.453-.016-.752-.027-.63-.219-1.141-.576-1.536s-.888-.592-1.592-.592ZM6.48 13.304c-.41 0-.768.084-1.072.252a1.809 1.809 0 0 0-.96 1.548.163.163 0 0 0 .168.168h.72a.267.267 0 0 0 .148-.044.222.222 0 0 0 .092-.14c.037-.25.132-.455.284-.612.152-.157.361-.236.628-.236.272 0 .475.072.608.216.133.144.2.341.2.592a.88.88 0 0 1-.152.472 2.74 2.74 0 0 1-.46.524c-.205.19-.497.433-.876.732l-1.248 1.24a.457.457 0 0 0-.2.376v.416c0 .053.019.099.056.136a.185.185 0 0 0 .136.056h3.832a.203.203 0 0 0 .144-.052.182.182 0 0 0 .056-.14v-.576a.195.195 0 0 0-.056-.144.195.195 0 0 0-.144-.056H6.12l1.112-1.128c.421-.33.732-.641.932-.932.2-.29.3-.615.3-.972 0-.325-.075-.616-.224-.872a1.535 1.535 0 0 0-.672-.604c-.299-.147-.661-.22-1.088-.22Zm11.152.936c.33.005.579.117.744.336.165.219.253.523.264.912.005.144.008.376.008.696 0 .32-.003.557-.008.712-.01.4-.099.708-.264.924-.165.216-.413.324-.744.324-.33 0-.579-.108-.744-.324-.165-.216-.253-.524-.264-.924a22.792 22.792 0 0 1-.008-.712v-.181c.001-.228.004-.4.008-.515.01-.39.099-.693.264-.912.165-.219.413-.33.744-.336ZM18 2c.6 0 1 .4 1 1v2h2c.5 0 1 .5 1 1v3H2V6c0-.5.5-1 1-1h2V3c0-.6.4-1 1-1s1 .4 1 1v2h4V3c0-.6.4-1 1-1s1 .4 1 1v2h4V3c0-.6.4-1 1-1Z"
      />
    </defs>
    <use xlink:href="#Calendar2-a" fill="#000" fill-rule="evenodd" />
  </svg>

  <svg
    v-else-if="icon == 'Camera'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#camera-a"
  >
    <path
      id="camera-a"
      d="M18.524 10.225a1.077 1.077 0 01-1.08-1.084 1.08 1.08 0 011.09-1.099 1.078 1.078 0 011.092 1.098 1.076 1.076 0 01-1.102 1.085m-1.621 2.942c-.11 2.514-2.16 4.706-4.944 4.688-2.804-.019-4.98-2.351-4.863-5.127.109-2.548 2.216-4.696 4.919-4.687 2.744-.002 5.01 2.297 4.888 5.126m6.972-5.853c-.253-.83-.868-1.242-1.684-1.393a3.858 3.858 0 00-.683-.052 383.917 383.917 0 00-3.624.002c-.162 0-.258-.04-.343-.19-.275-.486-.571-.962-.86-1.442-.213-.357-.53-.544-.944-.545a3696.94 3696.94 0 00-7.477 0c-.415 0-.73.19-.944.547-.27.451-.55.896-.806 1.356-.111.201-.237.279-.474.276a185.131 185.131 0 00-3.777-.002c-.58.005-1.122.17-1.571.559-.413.357-.613.82-.643 1.362-.004.074-.03.146-.045.22V18.99c.042.232.064.47.13.695.227.771.945 1.323 1.792 1.4.092.009.183.033.274.05h19.608c.231-.049.466-.082.692-.15.902-.267 1.386-.87 1.46-1.8.008-.083.03-.164.044-.246V8.011c-.04-.233-.057-.473-.125-.697"
    />
  </svg>

  <svg
    v-else-if="icon == 'Chevron Left'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#chevronleft-a"
  >
    <path
      id="chevronleft-a"
      d="M16.657 5.037L9.827 12l6.83 6.963a1.21 1.21 0 010 1.687 1.155 1.155 0 01-1.656 0l-7.658-7.806a1.21 1.21 0 010-1.688L15 3.35a1.155 1.155 0 011.656 0 1.21 1.21 0 010 1.687z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Chevron Right'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#chevronright-a"
  >
    <path
      transform="rotate(180,12,12)"
      id="chevronright-a"
      d="M16.657 5.037L9.827 12l6.83 6.963a1.21 1.21 0 010 1.687 1.155 1.155 0 01-1.656 0l-7.658-7.806a1.21 1.21 0 010-1.688L15 3.35a1.155 1.155 0 011.656 0 1.21 1.21 0 010 1.687z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Close'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#close-a"
  >
    <path
      id="close-a"
      d="M3.343 3.35a1.155 1.155 0 011.656 0l6.751 6.881 6.751-6.881a1.154 1.154 0 011.56-.087l.096.087a1.21 1.21 0 010 1.687L13.327 12l6.83 6.963a1.21 1.21 0 010 1.687 1.155 1.155 0 01-1.656 0l-6.751-6.882-6.751 6.882a1.154 1.154 0 01-1.56.087l-.096-.087a1.21 1.21 0 010-1.687L10.173 12l-6.83-6.963a1.21 1.21 0 010-1.687z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Copy Link'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      id="copyLink-a"
      d="M14.484 7.403a6.33 6.33 0 011.184 9.87v.001l-4.877 4.877a6.33 6.33 0 01-8.942 0 6.329 6.329 0 010-8.941l3.38-3.38a7.743 7.743 0 00.491 4.386l-1.433 1.432a2.877 2.877 0 000 4.065 2.877 2.877 0 004.065 0l4.877-4.877a2.877 2.877 0 000-4.065 2.85 2.85 0 00-1.356-.756zM13.21 1.85a6.329 6.329 0 018.941 0 6.329 6.329 0 010 8.941l-3.38 3.38a7.747 7.747 0 00-.49-4.385l1.432-1.433a2.877 2.877 0 000-4.064 2.877 2.877 0 00-4.064 0l-4.877 4.877a2.877 2.877 0 000 4.064c.387.387.859.638 1.356.757l-2.611 2.61a6.329 6.329 0 01-1.184-9.87z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Country'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      id="country-a"
      d="M12.078.233C5.76.233.61 5.393.61 11.76c0 6.366 5.151 11.527 11.468 11.527s11.58-5.16 11.58-11.527c0-6.366-5.263-11.527-11.58-11.527zm9.107 15.133h-3.053c.166-.845.268-1.757.288-2.737h3.407c-.083.959-.305 1.877-.642 2.737zm.643-4.47H18.37c-.072-.938-.219-1.83-.422-2.666h3.266c.321.84.532 1.734.613 2.666zm-1.482-4.4h-2.931c-.696-1.85-1.69-3.316-2.781-4.238 2.39.65 4.418 2.188 5.712 4.239zm-7.35-3.576c1.06.492 1.997 1.789 2.646 3.577h-2.646V2.92zm0 5.31h3.148c.186.83.318 1.726.384 2.666h-3.532V8.23zm3.576 4.399c-.019.991-.115 1.904-.27 2.737h-3.306v-2.737h3.576zm-14.266 0h3.372c.02.98.122 1.893.288 2.737H2.948c-.337-.86-.559-1.778-.642-2.737zm5.33 0h3.574v2.737H7.893c-.148-.834-.24-1.746-.258-2.737zm.04-1.733c.063-.94.189-1.835.367-2.666h3.167v2.666H7.677zm3.534-8.022v3.623H8.525c.645-1.846 1.593-3.169 2.685-3.623zm-1.76-.602c-1.086.923-2.073 2.384-2.765 4.225H3.787C5.072 4.46 7.08 2.93 9.449 2.272zM2.918 8.23H6.15c-.204.837-.35 1.728-.423 2.666H2.305c.08-.932.292-1.827.613-2.666zm.917 8.87h2.593c.602 1.755 1.512 3.107 2.546 4.002-2.133-.712-3.94-2.141-5.139-4.003zm4.489 0h2.886v3.584c-1.213-.394-2.246-1.652-2.886-3.585zm4.672 3.549v-3.55h2.855c-.647 1.877-1.673 3.12-2.855 3.55zm2.106.473c1.043-.895 1.962-2.255 2.568-4.023h2.628c-1.21 1.878-3.038 3.316-5.196 4.023z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Delete'"
    viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 1C7.4 1 6.5 1.9 6.5 3V4.5H2C1.45 4.5 1 4.95 1 5.5C1 6.05 1.45 6.5 2 6.5H4V21.5C4 22.6 4.9 23.5 6 23.5H18C19.1 23.5 20 22.6 20 21.5V6.5H22C22.55 6.5 23 6.05 23 5.5C23 4.95 22.55 4.5 22 4.5H17.5V3C17.5 1.9 16.6 1 15.5 1H8.5ZM8.5 4.5H15.5V3H8.5V4.5ZM8 8.5C7.45 8.5 7 8.95 7 9.5V19.5C7 20.05 7.45 20.5 8 20.5C8.55 20.5 9 20.05 9 19.5V9.5C9 8.95 8.55 8.5 8 8.5ZM12 8.5C11.45 8.5 11 8.95 11 9.5V19.5C11 20.05 11.45 20.5 12 20.5C12.55 20.5 13 20.05 13 19.5V9.5C13 8.95 12.55 8.5 12 8.5ZM15 9.5C15 8.95 15.45 8.5 16 8.5C16.55 8.5 17 8.95 17 9.5V19.5C17 20.05 16.55 20.5 16 20.5C15.45 20.5 15 20.05 15 19.5V9.5Z" />
  </svg>

  <svg
    v-else-if="icon == 'Download'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <path id="download-a" d="M14 9h4l-6 8-6-8h4V2h4v7zM4 20h16v2H4v-2z" />
    <g fill="currentColor" fill-rule="evenodd">
      <mask id="download-b" fill="#fff"><use xlink:href="#download-a" /></mask>
      <use fill="#D8D8D8" xlink:href="#download-a" />
      <g class="download-icon" mask="url(#download-b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>

  <svg
    v-else-if="icon == 'Email'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 16"
  >
    <defs>
      <filter
        id="Email-a"
        width="119.4%"
        height="262.5%"
        x="-9.7%"
        y="-81.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="8"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <path
        id="Email-b"
        d="M15.936 1.136A1.546 1.546 0 0014.436 0H1.628C.711 0 .036.676.036 1.592v8.74a1.549 1.549 0 001.243 1.544.364.364 0 01.068.03h13.338a.695.695 0 01.083-.033c.633-.166 1.03-.564 1.194-1.194a.669.669 0 01.033-.083V1.308c-.02-.058-.041-.114-.059-.172zm-14.216.11h12.65c.15 0 .289.025.347.177.009.07 0 .14-.026.206-.005.021-.034.037-.052.055L8.327 7.997c-.24.238-.363.24-.6 0L1.413 1.685s-.513-.44.306-.44zm13.032 9.035c0 .267-.112.378-.38.378H1.676c-.259 0-.383-.112-.383-.363v-6.84c0-.024 0-.048.005-.073l.053-.036c.032.053.069.104.11.151 1.794 1.797 3.59 3.593 5.388 5.389.717.717 1.64.719 2.355.004l5.389-5.389c.043-.043.082-.093.15-.174.007.09.014.133.014.175-.004 2.719-.004 4.063-.004 6.78v-.002z"
      />
    </defs>
    <g
      fill="none"
      fill-rule="evenodd"
      filter="url(#Email-a)"
      transform="translate(0 2)"
    >
      <mask id="Email-c" fill="currentColor">
        <use xlink:href="#Email-b" />
      </mask>
      <use fill="currentColor" fill-rule="nonzero" xlink:href="#Email-b" />
      <g fill="currentColor" mask="url(#Email-c)"><path d="M0-2h16v16H0z" /></g>
    </g>
  </svg>

  <svg
    v-else-if="icon == 'Email Filled'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <defs>
      <path
        id="emailFilled-a"
        d="M21.133.325v2.668c-.05.06-.095.109-.136.15l-.11.11-8.083 8.084c-1.073 1.072-2.457 1.07-3.532-.007a9287.709 9287.709 0 01-8.083-8.082c-.104-.109-.104-.109-.252-.255V.325l10.116 9.939 10.08-9.94z"
      />
    </defs>
    <rect width="24" height="18" x=".053" y="3" rx="1" />
    <g transform="translate(1 5)">
      <use fill="#D8D8D8" xlink:href="#emailFilled-a" />
    </g>
  </svg>

  <svg
    v-else-if="icon == 'External Link'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <defs>
      <path
        id="externalLink-a"
        d="M8.005 0c.552 0 1 .448 1 1s-.448 1-1 1H2v20h20v-5.833c0-.553.448-1 1-1s1 .447 1 1V23c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1zm15.082 0c.432 0 .794.329.889.77l.017.113C23.998.922 24 .961 24 1v8c0 .552-.448 1-1 1s-1-.448-1-1V3.413L10.808 14.607c-.39.39-1.024.39-1.415 0-.39-.39-.39-1.024 0-1.415L20.585 2h-5.672c-.468 0-.854-.386-.907-.883L14 1c0-.552.409-1 .913-1z"
      />
    </defs>
    <use xlink:href="#externalLink-a" fill-rule="evenodd" />
  </svg>

  <svg
    v-else-if="icon == 'Facebook'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#facebook-a"
  >
    <path
      id="facebook-a"
      d="M24 4c0-2.102-1.898-4-4-4H4C1.898 0 0 1.898 0 4v16c0 2.102 1.898 4 4 4h8v-9.067H9.067v-4H12V9.375c0-2.688 2.018-5.108 4.5-5.108h3.233v4H16.5c-.354 0-.767.43-.767 1.073v1.593h4v4h-4V24H20c2.102 0 4-1.898 4-4V4z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Feed'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M21.55 0c1.291 0 2.229.644 2.228 1.532v14.32c0 .887-.937 1.532-2.228 1.532h-5.716l-.074.122-3.87 6.37-3.872-6.37-.074-.122H2.228C.937 17.384 0 16.74 0 15.852V1.532C0 .644.937 0 2.228 0zm.473 2.107h-20v13.168l4.637.002.021.032-.02-.034h2.71l2.514 4.138 2.514-4.138h2.71l-.02.034.02-.032 4.914-.002V2.107zm-2.843 7.56v1.953H4.6V9.668h14.58zm0-4.368V7.25H4.6V5.299h14.58z"
      id="feed-a"
    />
    <g transform="translate(.982)" fill="none" fill-rule="evenodd">
      <path d="M-.095.12h24v24h-24z" />
    </g>
  </svg>

  <svg
    v-else-if="icon == 'FullTime'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 14"
    fill="currentColor"
  >
    <path
      id="fullTime-b"
      d="M0 0h9.719v2.556h-6.68V5.75h5.79v2.362h-5.79v5.711H0V0zm16.817 2.556h-4.143V0H24v2.556h-4.143v11.267h-3.04V2.556z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Group'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fill="#D8D8D8"
      stroke="currentColor"
      d="M13.5 2.5h-11v11h11v-11Z"
      opacity=".5"
    />
    <path
      fill="currentColor"
      d="M13.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM2.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM2.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM13.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Hospitality'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    transform="rotate(-45)"
    xlink:href="#hospitality-a"
  >
    <path
      id="hospitality-a"
      d="M23 7v3.137a2.131 2.131 0 00-2.134 2.133c0 1.176.959 2.135 2.134 2.135v3.148H1v-3.17a2.13 2.13 0 001.983-2.122A2.12 2.12 0 001 10.147V7h22zm-6.624 1.486l-1.69 2.228-2.728-.62 1.596 2.297-1.432 2.402 2.677-.808 1.843 2.105.058-2.797 2.571-1.102-2.641-.92-.254-2.785zM8.783 16.97c0 .162-.183.29-.42.29-.226 0-.41-.128-.41-.29v-.982c0-.161.184-.29.41-.29.237 0 .42.129.42.29v.982zm0-2.081c0 .162-.183.291-.42.291-.226 0-.41-.13-.41-.291v-.982c0-.161.184-.29.41-.29.237 0 .42.129.42.29v.982zm0-2.08c0 .15-.183.28-.42.28-.226 0-.41-.13-.41-.28v-.991c0-.162.184-.292.41-.292.237 0 .42.13.42.292v.99zm0-2.09c0 .16-.183.29-.42.29-.226 0-.41-.13-.41-.29v-.983c0-.161.184-.29.41-.29.237 0 .42.129.42.29v.982zm0-2.082c0 .162-.183.291-.42.291-.226 0-.41-.13-.41-.291v-.98c0-.162.184-.292.41-.292.237 0 .42.13.42.291v.98z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Info'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.12 8.23c.483 0 .845.137 1.086.41.242.274.362.604.362.99 0 .16-.016.332-.048.515-.032.182-.102.37-.209.563l-1.223 2.686a5.786 5.786 0 00-.209.547c-.043.14-.064.236-.064.29 0 .064.016.104.048.12a.214.214 0 00.097.024c.236 0 .512-.169.828-.506.317-.338.518-.507.603-.507.075 0 .156.056.242.169.085.112.128.19.128.233 0 .172-.404.574-1.214 1.207-.81.632-1.542.949-2.196.949-.45 0-.777-.116-.981-.346a1.147 1.147 0 01-.306-.78c0-.183.027-.352.08-.507.054-.156.113-.314.178-.475l1.528-3.169c.086-.182.147-.33.185-.442a.958.958 0 00.056-.298c0-.085-.016-.147-.048-.185a.161.161 0 00-.129-.056c-.14 0-.41.212-.812.636-.402.423-.64.635-.716.635-.086 0-.172-.059-.257-.177-.086-.118-.129-.193-.129-.225 0-.107.102-.282.306-.523.203-.241.46-.496.772-.764a5.501 5.501 0 011.005-.692c.392-.214.737-.321 1.038-.321zM13.537 6c.408 0 .754.145 1.038.434.284.29.426.633.426 1.03s-.142.74-.426 1.03c-.284.289-.63.434-1.038.434-.397 0-.74-.145-1.03-.435a1.407 1.407 0 01-.434-1.03c0-.396.145-.74.435-1.029.29-.29.632-.434 1.03-.434z"
      id="info-a"
    />
  </svg>

  <svg
    v-else-if="icon == 'Instagram'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#instagram-a"
  >
    <path
      id="instagram-a"
      d="M8.6.012c2.389-.016 4.778-.019 7.167.008 1.257.014 2.52.057 3.728.478 2.315.807 3.679 2.447 4.195 4.818.236 1.084.25 2.19.257 3.29.016 2.38.018 4.76-.008 7.14-.014 1.266-.055 2.538-.48 3.754-.81 2.315-2.45 3.677-4.823 4.19-1.084.235-2.188.239-3.29.258-.372.007-.746.01-1.12.01l-2.24-.005v.033c-1.636-.029-3.272-.043-4.907-.09-1.387-.041-2.73-.3-3.933-1.04-1.578-.969-2.496-2.403-2.876-4.2-.23-1.085-.25-2.189-.258-3.29-.015-2.397-.02-4.795.009-7.193.014-1.256.06-2.518.485-3.726C1.314 2.14 2.952.788 5.31.27 6.394.033 7.499.02 8.6.012zm3.407 2.108v.046c-1.016 0-2.032-.026-3.046.008-1.02.034-2.05.055-3.056.211-1.73.269-2.925 1.253-3.393 2.974a8.612 8.612 0 00-.282 2.016 182.514 182.514 0 00-.063 6.036c.01 1.441.025 2.89.167 4.322.197 1.992 1.348 3.362 3.338 3.808 1.084.244 2.19.227 3.289.243 2.012.029 4.025.03 6.037 0 1.02-.016 2.05-.053 3.056-.21 1.728-.27 2.927-1.25 3.392-2.973.176-.651.265-1.34.283-2.016.053-2.028.077-4.059.064-6.088a57.636 57.636 0 00-.164-4.27c-.099-1.216-.605-2.273-1.609-3.036-.817-.622-1.769-.877-2.768-.92-1.747-.076-3.496-.104-5.245-.151zm.122 3.788c3.357.002 6.082 2.763 6.082 6.162 0 3.423-2.737 6.143-6.182 6.142-3.41-.001-6.122-2.75-6.121-6.202 0-3.397 2.76-6.105 6.221-6.102zm-.073 2.16c-2.19.006-3.99 1.81-3.988 3.995.003 2.188 1.81 3.991 3.996 3.988 2.187-.003 3.99-1.81 3.987-3.996-.003-2.187-1.813-3.993-3.995-3.987zm6.24-3.817c.813.005 1.423.637 1.416 1.464a1.445 1.445 0 01-1.446 1.424c-.797-.012-1.456-.682-1.443-1.466a1.444 1.444 0 011.473-1.422z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Lineups'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <path
      d="M9.158 9.941c1.644 1.598 2.581 1.505 2.842 1.505h.032c.298.005 1.227.033 2.81-1.505 0 0 4.49.347 4.49 6.806L12 23.907l-7.333-7.16c0-6.459 4.491-6.806 4.491-6.806zm-5.483-.583C5.02 10.666 5.787 10.59 6 10.59c.08 0 .236.01.47-.044-.96.8-1.892 2.146-2.259 4.382H0c0-5.286 3.675-5.57 3.675-5.57zm16.65 0S24 9.642 24 14.928h-4.211c-.367-2.236-1.3-3.582-2.26-4.382.236.055.392.045.471.045.213 0 .98.075 2.325-1.233zM12 1.007c2.147 0 3.889 1.391 3.889 3.934 0 2.545-1.742 5.278-3.889 5.278-2.148 0-3.889-2.733-3.89-5.277 0-2.544 1.742-3.935 3.89-3.935zm-6 1.04c.774 0 1.474.233 2.027.658a4.917 4.917 0 00-.464 2.142c0 1.101.287 2.231.774 3.212-.582.895-1.41 1.526-2.337 1.526-1.757 0-3.182-2.237-3.182-4.318 0-2.081 1.425-3.22 3.182-3.22zm12 0c1.758 0 3.181 1.137 3.181 3.22 0 2.081-1.423 4.318-3.181 4.318-.928 0-1.756-.631-2.338-1.526a7.32 7.32 0 00.775-3.212c0-.827-.175-1.534-.463-2.142.55-.425 1.251-.658 2.026-.658z"
      id="lineups-a"
    />
    <mask id="lineups-b" fill="#fff"></mask>
    <g mask="url(#lineups-b)" fill="#AAA"><path d="M0 0h24v24H0z" /></g>
  </svg>

  <svg
    v-else-if="icon == 'Linkedin'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <path
      id="linkedin"
      d="M19.5 19.839c0 .273-.212.494-.473.494h-2.352c-.26 0-.473-.221-.473-.494v-4.502c0-.671.189-2.942-1.68-2.942-1.448 0-1.742 1.554-1.801 2.252v5.192c0 .273-.212.494-.474.494H9.973c-.261 0-.473-.221-.473-.494v-9.683c0-.274.212-.495.473-.495h2.274c.262 0 .474.221.474.495v.837c.537-.843 1.335-1.493 3.036-1.493 3.765 0 3.743 3.675 3.743 5.694v4.645zM6.167 8.667c-1.15 0-2.084-.933-2.084-2.084 0-1.15.933-2.083 2.084-2.083 1.15 0 2.083.933 2.083 2.083 0 1.15-.933 2.084-2.083 2.084zm1.666 11.12c0 .302-.238.546-.532.546H5.033c-.294 0-.533-.244-.533-.546v-9.741c0-.302.239-.546.533-.546H7.3c.294 0 .532.244.532.546v9.741zM20.191 2H3.809C2.81 2 2 2.81 2 3.81v16.38c0 1 .81 1.81 1.81 1.81h16.38c1 0 1.81-.81 1.81-1.81V3.81c0-1-.81-1.81-1.81-1.81z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Live'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      id="live-a"
      d="M20 6c2.21 0 4 1.79 4 4v5c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4v-5c0-2.21 1.79-4 4-4h16zM4.372 9H3v7h4.413v-1.294H4.372V9zm5.181 0H8.182v7h1.371V9zm1.949 0h-1.407l2.019 7h1.546l2.071-7h-1.415l-1.407 4.922h-.018L11.501 9zm9.428 0h-4.666v7H21v-1.294h-3.364V12.99h3.023v-1.196h-3.023v-1.5h3.294V9z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Match'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#match-a"
  >
    <path
      id="match-a"
      d="M11.467 2.517v5.058c-2.248.35-3.8 1.971-3.999 4.18-.089.995.156 1.924.695 2.763.777 1.21 1.906 1.888 3.332 2.097V21.5H0v-4.862h3.77c.471 0 .652-.179.652-.645V8.195c0-.471-.18-.653-.644-.653C2.641 7.54 1.505 7.54.368 7.54H.024V2.517h11.443zM24 2.5v5.042c-1.263 0-2.526-.002-3.79 0-.447 0-.631.184-.632.632v7.831c0 .447.185.632.633.632 1.263.002 2.526 0 3.789 0V21.5H12.505v-4.876c2.57-.407 3.928-2.362 4.036-4.296a4.386 4.386 0 00-.773-2.772c-.782-1.148-1.885-1.79-3.24-1.989V2.5H24zm0 6.053v7.073h-3.388V8.553H24zm-20.771.003c.05 0 .1.007.164.012v7.033H.023V8.555zm9.29.086c1.369-.097 2.945 1.616 3.017 3.235.1 2.267-1.745 3.616-3.017 3.672zm-1.038-.012v6.906c-1.368.099-2.948-1.621-3.017-3.235-.097-2.247 1.723-3.611 3.017-3.67z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Microphone'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <defs>
      <path
        id="microphone-a"
        d="M18 11a1 1 0 0 1 .993.883L19 12a7.002 7.002 0 0 1-5.999 6.929L13 21h2a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2h2v-2.07A7.002 7.002 0 0 1 5 12a1 1 0 0 1 1.993-.117L7 12a5 5 0 0 0 10 0 1 1 0 0 1 1-1ZM12 1a3 3 0 0 1 3 3v8a3 3 0 0 1-6 0V4l.005-.176A3 3 0 0 1 12 1Z"
      />
    </defs>
    <use xlink:href="#microphone-a" fill="#000" fill-rule="evenodd" />
  </svg>

  <svg
    v-else-if="icon == 'Notification'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="18px"
    height="18px"
  >
    <path
      d="M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z"
    />
    <path d="M0 0h24v24H0V0z" fill="none" />
  </svg>

  <svg
    v-else-if="icon == 'Padlock'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      id="padlock-39fhzhzs1a"
      d="M18 10.667c1.105 0 2 .895 2 2V22c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2v-9.333c0-1.105.895-2 2-2h12zm-6 4c-.736 0-1.333.597-1.333 1.333 0 .458.23.863.583 1.103l.122.073L10.667 20h2.666l-.705-2.823c.42-.225.705-.668.705-1.177 0-.736-.597-1.333-1.333-1.333zM12 0c3.604 0 6.54 2.86 6.663 6.433l.004.234v2.666H16V6.667c0-2.21-1.79-4-4-4s-4 1.79-4 4v2.666H5.333V6.667C5.333 2.985 8.318 0 12 0z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Phone'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 16"
  >
    <defs>
      <filter
        id="phone-a"
        width="119.4%"
        height="262.5%"
        x="-9.7%"
        y="-81.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="8"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <path
        id="phone-b"
        d="M11.758 15.982c-.283-.06-.57-.106-.848-.18-2.63-.706-4.887-2.037-6.766-4.014-.79-.83-1.549-1.682-2.198-2.63C1.254 8.148.845 7.012.433 5.874c-.253-.7-.47-1.406-.428-2.162C.07 2.517.574 1.513 1.369.643c.242-.265.574-.374.91-.454.307-.073.621-.119.933-.176.315-.057.535.07.686.347.195.36.392.72.598 1.073.355.61.718 1.217 1.078 1.825l.121.205c.165.278.156.552-.069.784-.26.27-.542.521-.82.774-.274.249-.56.484-.832.735-.225.207-.293.466-.131.734.443.735.864 1.487 1.36 2.184.852 1.197 1.964 2.12 3.225 2.866.352.209.711.405 1.071.6.261.14.505.089.703-.122.245-.259.476-.53.714-.797.233-.261.451-.537.703-.779.36-.343.583-.349 1.012-.096.791.467 1.584.93 2.376 1.393.24.14.482.274.72.418.18.108.257.27.244.484-.032.553-.138 1.094-.379 1.59-.11.228-.305.435-.506.597-.75.602-1.589 1.018-2.56 1.124-.032.004-.062.02-.093.03h-.675z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd" filter="url(#phone-a)">
      <mask id="phone-c" fill="currentColor"><use xlink:href="#b" /></mask>
      <use fill="currentColor" xlink:href="#phone-b" />
      <g fill="currentColor" mask="url(#phone-c)"><path d="M0 0h16v16H0z" /></g>
    </g>
  </svg>

  <!-- <svg v-else-if="icon == 'Play'" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" xlink:href="#play-a"><path id="play-a" d="M13.317 9.342 2.17 14.915A1.5 1.5 0 0 1 0 13.573V2.427a1.5 1.5 0 0 1 2.17-1.342l11.147 5.573a1.5 1.5 0 0 1 0 2.684Z" fill="curentColor" fill-rule="evenodd"/></svg> -->

  <svg
    v-else-if="icon == 'Player'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#player-a"
  >
    <path
      id="player-a"
      d="M16.485 18.019a1.166 1.166 0 11.003 2.332 1.166 1.166 0 01-.003-2.332zm-.626-4.972s6.556.507 6.556 9.939H1c0-9.432 6.559-9.939 6.559-9.939 2.4 2.333 3.769 2.199 4.15 2.199.379 0 1.75.134 4.15-2.199zm.626 8.16c1.712 0 2.177-3.282 1.97-3.304-1.278-.13-1.82-1.034-1.97-1.034-.145 0-.689.903-1.968 1.034-.203.022.26 3.303 1.968 3.303zm-4.776-7.753c-3.137 0-5.68-3.992-5.68-7.708C6.029 2.032 8.572 0 11.709 0c3.136 0 5.679 2.032 5.679 5.746 0 3.715-2.543 7.708-5.68 7.708z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Plus'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#plus-a"
  >
    <path
      id="plus-a"
      d="M14 10V.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V10H.5a.5.5 0 00-.5.5v3a.5.5 0 00.5.5H10v9.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V14h9.5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5H14z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Position'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#position-a"
    fill-rule="evenodd"
  >
    <path
      d="M12 20c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2ZM2 14c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2Zm20 0c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2ZM8 14c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2Zm8 0c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2ZM2 7c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2Zm20 0c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2ZM8 7c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2Zm8 0c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2ZM8 0c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2Zm8 0c1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2-2-.8954305-2-2 .8954305-2 2-2Z"
      id="a"
    />
  </svg>

  <svg
    v-else-if="icon == 'Quiz'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      id="quiz-a"
      d="M22,0 C23.1045695,-2.02906125e-16 24,0.8954305 24,2 L24,18 C24,19.1045695 23.1045695,20 22,20 L15,20 L12.0545524,24 L9,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,-2.41183085e-16 2,0 L22,0 Z M11.4121094,13.4599609 C10.6210938,13.4599609 9.97949219,14.0664062 9.97949219,14.8398438 C9.97949219,15.6132812 10.6210938,16.2197266 11.4121094,16.2197266 C12.2119141,16.2197266 12.8535156,15.6132812 12.8535156,14.8398438 C12.8535156,14.0664062 12.2119141,13.4599609 11.4121094,13.4599609 Z M11.7460938,3.203125 C9.85644531,3.203125 8.45019531,3.95019531 7.88769531,5.11035156 C7.71191406,5.44433594 7.62402344,5.77832031 7.62402344,6.15625 C7.62402344,6.82421875 8.0546875,7.25488281 8.74902344,7.25488281 C9.28515625,7.25488281 9.68066406,7.00878906 9.90039062,6.44628906 C10.1816406,5.6640625 10.7617188,5.2421875 11.6230469,5.2421875 C12.5898438,5.2421875 13.2578125,5.83984375 13.2578125,6.70117188 C13.2578125,7.50976562 12.9150391,7.94921875 11.78125,8.62597656 C10.7441406,9.23242188 10.2080078,9.91796875 10.2080078,10.9550781 L10.2080078,11.078125 C10.2080078,11.7988281 10.6474609,12.3085938 11.3945312,12.3085938 C12.0185547,12.3085938 12.3613281,11.9658203 12.4931641,11.3769531 C12.6074219,10.6386719 12.8710938,10.2607422 14.0400391,9.58398438 C15.2792969,8.85449219 15.9208984,7.94921875 15.9208984,6.62207031 C15.9208984,4.57421875 14.2421875,3.203125 11.7460938,3.203125 Z"
    ></path>
  </svg>

  <svg
    v-else-if="icon == 'Refine'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#refine-a"
  >
    <path
      d="M9.5,17 C10.6045695,17 11.5,17.8954305 11.5,19 C11.5,20.1045695 10.6045695,21 9.5,21 C8.3954305,21 7.5,20.1045695 7.5,19 C7.5,17.8954305 8.3954305,17 9.5,17 Z M6.54157652,18.4994204 C6.51423316,18.6622073 6.5,18.8294415 6.5,19 C6.5,19.1705992 6.51423996,19.3378726 6.5415961,19.5006962 L2,19.5 L2,18.5 L6.54157652,18.4994204 Z M12.4584235,18.4994204 L22,18.5 L22,19.5 L12.4584039,19.5006962 C12.48576,19.3378726 12.5,19.1705992 12.5,19 C12.5,18.8294415 12.4857668,18.6622073 12.4584235,18.4994204 Z M16.5,10 C17.6045695,10 18.5,10.8954305 18.5,12 C18.5,13.1045695 17.6045695,14 16.5,14 C15.3954305,14 14.5,13.1045695 14.5,12 C14.5,10.8954305 15.3954305,10 16.5,10 Z M13.5415765,11.4994204 C13.5142332,11.6622073 13.5,11.8294415 13.5,12 C13.5,12.1705992 13.51424,12.3378726 13.5415961,12.5006962 L2,12.5 L2,11.5 L13.5415765,11.4994204 Z M22,11.5 L22,12.5 L19.4584039,12.5006962 C19.48576,12.3378726 19.5,12.1705992 19.5,12 C19.5,11.8294415 19.4857668,11.6622073 19.4584235,11.4994204 L22,11.5 Z M6.5,3 C7.6045695,3 8.5,3.8954305 8.5,5 C8.5,6.1045695 7.6045695,7 6.5,7 C5.3954305,7 4.5,6.1045695 4.5,5 C4.5,3.8954305 5.3954305,3 6.5,3 Z M3.54157652,4.49942039 C3.51423316,4.66220728 3.5,4.82944147 3.5,5 C3.5,5.17059924 3.51423996,5.33787255 3.5415961,5.50069618 L2,5.5 L2,4.5 L3.54157652,4.49942039 Z M9.45842348,4.49942039 L22,4.5 L22,5.5 L9.4584039,5.50069618 C9.48576004,5.33787255 9.5,5.17059924 9.5,5 C9.5,4.82944147 9.48576684,4.66220728 9.45842348,4.49942039 Z"
      id="refine-a"
    ></path>
  </svg>

  <svg
    v-else-if="icon == 'Refresh'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#refresh-a"
  >
    <path
      d="M19.5072932,9.29391376 C19.8972631,8.90394389 20.5302142,8.90394389 20.921184,9.29391376 L20.921184,9.29391376 L23.8299592,13.5945815 C24.1379354,14.053546 24.0159449,14.6744981 23.5579802,14.9824743 C23.1000156,15.2924503 22.4770638,15.16746 22.1700875,14.7094954 L22.1700875,14.7094954 L21.1771642,13.2306096 C20.8021931,18.1272313 16.7065096,21.9999321 11.7148952,21.9999321 C9.00010493,21.9999321 6.40930508,20.8350221 4.60644437,18.8031791 C4.24047264,18.3892111 4.27746978,17.7572599 4.69043788,17.3912882 C5.10340597,17.0243165 5.73635707,17.0613137 6.10332872,17.4752817 C7.5262188,19.0801577 9.57106082,20.0000866 11.7148952,20.0000866 C15.7585828,20.0000866 19.0553281,16.7823352 19.2003169,12.7736449 L19.2003169,12.7736449 L17.775427,14.4795131 C17.4214543,14.9054802 16.791503,14.960476 16.3675358,14.6065033 C15.9435685,14.2515308 15.8875728,13.6215794 16.2405456,13.1986121 L16.2405456,13.1986121 Z M12.2853511,3 C15.0001414,3 17.5899413,4.16491 19.392802,6.19675303 C19.7587738,6.61072105 19.7217766,7.24267223 19.3088085,7.60864396 C18.8958404,7.97361576 18.2638892,7.93861846 17.8969176,7.52465044 C16.4730276,5.91977443 14.4281856,4.9998455 12.2853511,4.9998455 C8.24166352,4.9998455 4.94491822,8.21759691 4.79892949,12.2262872 L4.79892949,12.2262872 L6.22381941,10.520419 C6.57879199,10.0954518 7.20874332,10.0394562 7.63171065,10.3934288 C8.05567789,10.7484014 8.11267349,11.3783527 7.75870084,11.80132 L7.75870084,11.80132 L4.49295313,15.7060184 C4.10198334,16.0959883 3.46903224,16.0959883 3.07906236,15.7060184 L3.07906236,15.7060184 L0.169287162,11.4053506 C-0.137689123,10.9463861 -0.0156985471,10.3254341 0.442266072,10.0174579 C0.900230692,9.70748181 1.52318257,9.83247215 1.83015885,10.2904368 L1.83015885,10.2904368 L2.82308214,11.7693225 C3.19805317,6.87270081 7.29273683,3 12.2853511,3 Z"
      id="refresh-a"
    ></path>
  </svg>

  <svg
    v-else-if="icon == 'Search'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#search-a"
  >
    <path
      id="search-a"
      d="M16.647 17.782l.624-.511.511-.624a7.967 7.967 0 001.792-5.5 8 8 0 10-8.427 8.427 7.967 7.967 0 005.5-1.792zm-12.132.875C.609 14.752.609 8.42 4.515 4.515 8.42.609 14.752.609 18.657 4.515c3.666 3.666 3.89 9.472.672 13.4l2.863 2.863-1.414 1.414-2.863-2.863c-3.928 3.219-9.734 2.994-13.4-.672z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Scores'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#scores-a"
  >
    <path
      d="M11 11v11H3c-.464 0-.929-.431-.993-.893L2 21V11h9zm11 0v10c0 .464-.431.929-.893.993L21 22h-8V11h9zm-4.368 2.32c-.704 0-1.235.197-1.592.592-.357.395-.55.907-.576 1.536-.004.1-.006.244-.007.434v.63c.001.187.003.328.007.424.032.64.223 1.157.572 1.552.35.395.881.592 1.596.592.715 0 1.247-.197 1.596-.592.35-.395.54-.912.572-1.552.01-.288.016-.533.016-.736 0-.203-.005-.453-.016-.752-.027-.63-.219-1.141-.576-1.536s-.888-.592-1.592-.592zM6.48 13.304c-.41 0-.768.084-1.072.252a1.809 1.809 0 00-.96 1.548.163.163 0 00.168.168h.72a.267.267 0 00.148-.044.222.222 0 00.092-.14c.037-.25.132-.455.284-.612.152-.157.361-.236.628-.236.272 0 .475.072.608.216.133.144.2.341.2.592a.88.88 0 01-.152.472 2.74 2.74 0 01-.46.524c-.205.19-.497.433-.876.732l-1.248 1.24a.457.457 0 00-.2.376v.416c0 .053.019.099.056.136a.185.185 0 00.136.056h3.832a.203.203 0 00.144-.052.182.182 0 00.056-.14v-.576a.195.195 0 00-.056-.144.195.195 0 00-.144-.056H6.12l1.112-1.128c.421-.33.732-.641.932-.932.2-.29.3-.615.3-.972 0-.325-.075-.616-.224-.872a1.535 1.535 0 00-.672-.604c-.299-.147-.661-.22-1.088-.22zm11.152.936c.33.005.579.117.744.336.165.219.253.523.264.912.005.144.008.376.008.696 0 .32-.003.557-.008.712-.01.4-.099.708-.264.924-.165.216-.413.324-.744.324-.33 0-.579-.108-.744-.324-.165-.216-.253-.524-.264-.924a22.792 22.792 0 01-.008-.712v-.181c.001-.228.004-.4.008-.515.01-.39.099-.693.264-.912.165-.219.413-.33.744-.336zM18 2c.557 0 .942.345.994.875L19 3v2h2c.464 0 .929.431.993.893L22 6v3H2V6c0-.464.431-.929.893-.993L3 5h2V3c0-.6.4-1 1-1 .557 0 .942.345.994.875L7 3v2h4V3c0-.6.4-1 1-1 .557 0 .942.345.994.875L13 3v2h4V3c0-.6.4-1 1-1z"
      id="scores-a"
    />
    <mask id="scores-b" fill="#fff"></mask>
    <g mask="url(#scores-b)" fill="#AAA"><path d="M0 0h24v24H0z" /></g>
  </svg>

  <svg
    v-else-if="icon == 'Share'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      id="share-a"
      d="M18.571 0a3.437 3.437 0 00-3.17 4.741L7.814 9.545a3.414 3.414 0 00-2.384-.974A3.437 3.437 0 002 12a3.437 3.437 0 003.429 3.429c.93 0 1.773-.368 2.392-.974l7.58 4.804A3.437 3.437 0 0018.572 24 3.437 3.437 0 0022 20.571a3.437 3.437 0 00-3.429-3.428 3.418 3.418 0 00-2.553 1.152l-7.527-4.76a3.407 3.407 0 000-3.07l7.527-4.76a3.412 3.412 0 002.553 1.152A3.437 3.437 0 0022 3.43 3.437 3.437 0 0018.571 0z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Shirt' && shirtStyle === 'hollow'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#shirt-a"
  >
    <path
      id="shirt-a"
      d="M20.192 9.872l-1.807-.754a.817.817 0 00-1.133.755v11.123H6.77V9.863a.818.818 0 00-1.134-.755l-1.828.764-1.88-2.132 4.401-4.627h.965c.014.036.03.07.046.106a4.98 4.98 0 00.172.37c.026.05.052.1.08.15.038.07.08.137.121.204.029.046.056.093.086.137.047.07.097.138.147.206.029.038.056.078.086.116.063.08.13.157.198.234l.058.067c.089.097.182.19.278.279.026.024.053.045.08.069.072.063.144.127.22.186.038.03.078.058.117.087.066.05.132.099.2.145.045.03.09.057.136.085.066.042.133.083.2.121l.147.079a5.044 5.044 0 00.959.38c.053.014.107.03.16.043.08.02.16.036.24.052l.156.03c.09.014.18.024.271.034.045.005.09.012.134.016a5.17 5.17 0 00.826 0c.045-.004.09-.011.134-.016.09-.01.182-.02.271-.034.052-.009.104-.02.155-.03a5.14 5.14 0 00.241-.052c.054-.013.107-.028.16-.043a5.02 5.02 0 00.752-.278 4.854 4.854 0 00.558-.304c.044-.027.088-.054.13-.082.072-.048.14-.098.208-.15.037-.027.075-.053.111-.082a5.1 5.1 0 00.232-.197l.068-.058a5.3 5.3 0 00.28-.281l.045-.052c.073-.08.144-.164.212-.25l.08-.107c.052-.07.103-.141.152-.214.029-.043.056-.088.083-.132.043-.069.085-.138.125-.21.027-.048.052-.097.078-.147a4.975 4.975 0 00.173-.37c.014-.036.032-.07.046-.107h.964l4.402 4.627-1.88 2.132zm-5.358-6.693a3.37 3.37 0 01-.295.378l-.036.041a3.527 3.527 0 01-.18.18l-.035.031a3.568 3.568 0 01-.374.293l-.052.036a3.44 3.44 0 01-.217.13l-.034.017a3.32 3.32 0 01-.193.096l-.07.03a3.496 3.496 0 01-.177.07l-.066.025c-.08.027-.162.053-.245.074l-.025.006c-.074.018-.15.034-.227.048l-.078.013c-.063.01-.126.018-.19.024l-.077.008a3.495 3.495 0 01-.528 0l-.077-.008a3.368 3.368 0 01-.19-.024l-.078-.013a3.407 3.407 0 01-.226-.048l-.025-.006a3.232 3.232 0 01-.245-.074l-.066-.024a3.452 3.452 0 01-.177-.07l-.07-.03a3.378 3.378 0 01-.194-.097c-.01-.006-.022-.01-.033-.017a3.357 3.357 0 01-.217-.13l-.051-.035a3.495 3.495 0 01-.375-.294l-.035-.031a3.474 3.474 0 01-.18-.18l-.036-.04a3.386 3.386 0 01-.293-.377l-.033-.047c-.004-.007-.007-.014-.012-.02h5.755l-.012.02-.031.045zm8.94 3.977L18.803 1.93a.819.819 0 00-.732-.453H5.94l-.023.002a.814.814 0 00-.686.415L.224 7.156a.818.818 0 00-.02 1.105l2.764 3.133a.818.818 0 00.93.214l1.234-.517v10.723c0 .452.367.818.819.818H18.07a.818.818 0 00.818-.818V11.101l1.214.507a.819.819 0 00.929-.214l2.764-3.133a.818.818 0 00-.02-1.105z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Shirt' && shirtStyle === 'hoops'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#shirt-a"
  >
    <path
      id="shirt-a"
      d="M19 19c0 2-.113 3.01-2 3-3.216-.017-6.783 0-10 0-1.927 0-2-.65-2-3zm0-6v3H5v-3h14zM4.765 1.767c.724-.525 1.9-.185 2.87-.175.124 0 .258.377.368.593.39.768.897 1.373 1.47 1.815H5v3h14V4h-4.387c.576-.445 1.085-1.055 1.477-1.832.252-.499.517-.607.963-.656 1.331-.147 2.446.15 3.464 1.342C21.554 4.07 22.797 5.035 24 6.157c-.82 1.737-1.592 3.376-2.37 5.014-.051.11-.129.204-.24.374-.693-.427-1.54-1.025-2.39-1.545H5l-.6.384c-.606.399-1.226.83-1.818 1.196L0 6.16c1.584-1.5 3.066-3.158 4.765-4.393zM15.055 1l.565.373c.154.499-1.029 1.807-1.964 2.25-2.052.97-4.364.009-5.222-2.23l.693-.34c1.146 2.302 4.105 2.851 5.928-.053z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Shirt' && (shirtStyle === 'plain' || !shirtStyle)"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#shirt-a"
  >
    <path
      id="shirt-a"
      d="M4.765 1.767c.724-.525 1.9-.185 2.87-.175.124 0 .258.377.368.593 1.843 3.619 6.249 3.624 8.087-.017.252-.499.517-.607.963-.656 1.331-.147 2.446.15 3.464 1.342C21.554 4.07 22.797 5.035 24 6.157c-.82 1.737-1.592 3.376-2.37 5.014-.051.11-.129.204-.24.374l-2.234-1.373v1.13c0 2.796.015 5.59-.003 8.387-.014 2.249-.523 2.796-2.41 2.786-3.215-.017-6.432-.006-9.648-.006-1.928 0-2.249-.393-2.249-2.743v-9.542L2.582 11.58 0 6.16c1.584-1.5 3.066-3.158 4.765-4.393zm10.29-.813l.565.372c.154.5-1.029 1.808-1.964 2.252-2.052.97-4.364.008-5.222-2.232l.693-.339c1.146 2.302 4.105 2.85 5.928-.053z"
    />
  </svg>

  <!-- Sleeves -->

  <svg
    v-else-if="icon == 'Shirt' && shirtStyle === 'stripes'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#shirt-a"
  >
    <path
      id="shirt-a"
      d="M17.053 1.512c1.331-.147 2.446.15 3.464 1.342C21.554 4.07 22.797 5.035 24 6.157l-.8 1.696-4.04-3.778v3.206l3.101 2.559-.63 1.33c-.052.112-.13.205-.24.375l-2.235-1.373v1.13c0 2.796.015 5.59-.003 8.387-.014 2.143-.476 2.74-2.152 2.783L17 1.52zm-2.052 2.153v18.803c-.667-.002-1.333-.003-2-.003V4.785c.717-.175 1.406-.548 2-1.12zm-6-.082c.59.594 1.279.987 2 1.179v17.704l-3.906.003L9 22.467zM4.765 1.767c.571-.414 1.425-.29 2.236-.214l-.002 20.915c-1.842-.013-2.153-.432-2.153-2.742v-9.542L2.582 11.58l-.914-1.92L4.85 7.263V4.19L.75 7.73 0 6.16c1.584-1.5 3.066-3.158 4.765-4.393zm10.29-.813l.565.372c.154.5-1.029 1.808-1.964 2.252-2.052.97-4.364.008-5.222-2.232l.693-.339c1.146 2.302 4.105 2.85 5.928-.053z"
    />
  </svg>

  <svg
    v-else-if="icon == 'SignIn'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#signIn-a"
  >
    <path
      id="signIn-a"
      d="M12 0c6.627 0 12 5.265 12 11.76 0 6.496-5.373 11.76-12 11.76S0 18.257 0 11.76C0 5.265 5.373 0 12 0zm0 16.465c-3.082 0-5.793.988-7.365 2.484A10.473 10.473 0 0012 21.953c2.875 0 5.48-1.15 7.365-3.004-1.572-1.496-4.283-2.484-7.365-2.484zm0-11.18a4.799 4.799 0 000 9.595c2.65 0 4.8-2.147 4.8-4.797S14.65 5.286 12 5.286z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Slot'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
  >
    <mask
      id="slot-a"
      width="16"
      height="7"
      x="0"
      y="9"
      maskUnits="userSpaceOnUse"
      style="mask-type: luminance"
    >
      <path
        stroke="currentColor"
        stroke-dasharray="2 2"
        stroke-width="2"
        d="M15 10H1v5h14v-5Z"
      />
    </mask>
    <g mask="url(#slot-a)">
      <path
        stroke="currentColor"
        stroke-dasharray="2 2"
        stroke-width="2"
        d="M15 10H1v5h14v-5Z"
      />
    </g>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M1 7V2h14v5H8v1h1.007l-1.554 2-1.46-2h.992V7H1Zm5.552-4h-.44c-.07 0-.117.033-.144.1l-.96 2.58L5 5.716a.081.081 0 0 0 .084.084h.356a.116.116 0 0 0 .116-.076l.184-.484h1.184l.184.484c.021.05.06.076.116.076h.356c.021 0 .04-.008.058-.024a.078.078 0 0 0 .026-.06l-.008-.036-.96-2.58c-.027-.067-.075-.1-.144-.1Zm2.552 0h-.976a.09.09 0 0 0-.07.028.102.102 0 0 0-.026.072v2.604c0 .027.01.05.028.068a.093.093 0 0 0 .068.028h.996c.397 0 .691-.089.882-.266.19-.177.291-.453.302-.826l.008-.26V4.35a16.323 16.323 0 0 0-.008-.262C10.292 3.363 9.891 3 9.104 3Zm-.02.464c.224 0 .388.051.492.154.104.103.159.263.164.482l.008.264v.063l-.008.269c-.005.23-.057.393-.156.492-.099.099-.259.148-.48.148h-.508V3.464h.488Zm-2.752.08.452 1.232H5.88l.452-1.232Z"
      clip-rule="evenodd"
    />
  </svg>

  <svg
    v-else-if="icon == 'Snapchat'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#snapchat"
  >
    <path
      id="snapchat"
      d="M12.374 23.27h-.748c-.041-.015-.082-.04-.124-.042-.853-.043-1.595-.387-2.29-.85-.408-.272-.806-.555-1.212-.828a3.509 3.509 0 00-1.851-.588c-.692-.03-1.365.063-2.038.196-.342.067-.472-.016-.559-.356-.074-.292-.14-.586-.216-.877-.053-.204-.156-.336-.4-.356a4.255 4.255 0 01-.835-.157 15.914 15.914 0 01-1.51-.5c-.2-.081-.383-.26-.515-.439-.158-.21-.059-.387.196-.446.198-.045.399-.084.592-.145 2.241-.71 3.63-2.315 4.548-4.389.26-.586.063-1.086-.509-1.4-.361-.198-.77-.309-1.148-.48-.337-.153-.687-.3-.983-.514-.418-.304-.366-.754.081-1.012.317-.182.64-.225.99-.058.421.2.867.308 1.343.249.43-.054.52-.17.496-.601-.047-.836-.116-1.672-.113-2.507.002-.664.011-1.349.17-1.986.42-1.687 1.477-2.907 3.003-3.717C9.915.845 11.183.694 12.491.75c1.085.045 2.115.3 3.039.868 1.79 1.101 2.869 2.66 2.884 4.82.007 1.068-.052 2.136-.096 3.203-.02.484.072.65.565.628a3.927 3.927 0 001.153-.256c.372-.137.706-.136 1.049.042.525.273.583.756.094 1.084-.327.219-.706.36-1.068.523-.354.16-.735.27-1.07.463-.515.298-.666.761-.466 1.326.1.282.228.558.377.818 1.093 1.904 2.561 3.332 4.809 3.764.229.044.317.249.16.447-.145.18-.336.366-.546.444-.561.211-1.135.467-1.72.518-.781.067-1.083.428-1.168 1.158-.064.554-.197.606-.755.528-.035-.005-.07-.017-.104-.025a6.415 6.415 0 00-2.412-.07c-.733.124-1.312.567-1.899.983-.675.48-1.363.936-2.187 1.122-.25.056-.504.09-.756.133"
    />
  </svg>

  <svg
    v-else-if="icon == 'Spotify'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1333.33 1333.33"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    image-rendering="optimizeQuality"
    fill-rule="evenodd"
    clip-rule="evenodd"
    fill="currentColor"
  >
    <path
      d="M666.66 0C298.48 0 0 298.47 0 666.65c0 368.19 298.48 666.65 666.66 666.65 368.22 0 666.67-298.45 666.67-666.65C1333.33 298.49 1034.88.03 666.65.03l.01-.04zm305.73 961.51c-11.94 19.58-37.57 25.8-57.16 13.77-156.52-95.61-353.57-117.26-585.63-64.24-22.36 5.09-44.65-8.92-49.75-31.29-5.12-22.37 8.84-44.66 31.26-49.75 253.95-58.02 471.78-33.04 647.51 74.35 19.59 12.02 25.8 37.57 13.77 57.16zm81.6-181.52c-15.05 24.45-47.05 32.17-71.49 17.13-179.2-110.15-452.35-142.05-664.31-77.7-27.49 8.3-56.52-7.19-64.86-34.63-8.28-27.49 7.22-56.46 34.66-64.82 242.11-73.46 543.1-37.88 748.89 88.58 24.44 15.05 32.16 47.05 17.12 71.46V780zm7.01-189.02c-214.87-127.62-569.36-139.35-774.5-77.09-32.94 9.99-67.78-8.6-77.76-41.55-9.98-32.96 8.6-67.77 41.56-77.78 235.49-71.49 626.96-57.68 874.34 89.18 29.69 17.59 39.41 55.85 21.81 85.44-17.52 29.63-55.89 39.4-85.42 21.8h-.03z"
      fill-rule="nonzero"
    />
  </svg>

  <svg
    v-else-if="icon == 'Star'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <defs>
      <path
        id="star-a"
        d="m12 19-8 5 2.294-9.146L0 9l8.473-.854L12 0l3.527 8.146L24 9l-6.294 5.854L20 24z"
      />
    </defs>
    <use xlink:href="#star-a" fill="#000" fill-rule="evenodd" />
  </svg>

  <svg
    v-else-if="icon == 'Stats'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <path
      d="M15.15 16.278a1.12 1.12 0 011.128 1.108v4.51c0 .61-.507 1.104-1.128 1.104h-1.407a1.117 1.117 0 01-1.132-1.105v-4.51c0-.61.507-1.107 1.132-1.107zm-5.5 1.833c.62 0 1.128.483 1.128 1.072v2.75c0 .59-.507 1.067-1.129 1.067H8.24c-.624 0-1.128-.476-1.128-1.066v-2.75c0-.59.504-1.073 1.129-1.073zm11-8.555c.622 0 1.128.5 1.128 1.118v11.208c0 .618-.505 1.118-1.128 1.118h-1.411c-.621 0-1.128-.5-1.128-1.118V10.674c0-.618.507-1.118 1.128-1.118zM8.33 1c4.054 0 7.337 3.42 7.337 7.638 0 4.22-3.283 7.64-7.336 7.64C4.28 16.278 1 12.858 1 8.638 1 4.42 4.28 1 8.33 1zm.002 1.93c-3.028 0-5.48 2.556-5.48 5.708 0 3.155 2.452 5.71 5.48 5.71 1.838 0 3.465-.941 4.46-2.387l-4.46-3.31z"
      id="stats-a"
    />
    <mask id="stats-b" fill="#fff"></mask>
    <g mask="url(#stats-b)" fill="#AAA"><path d="M0 0h24v24H0z" /></g>
  </svg>

  <svg
    v-else-if="icon == 'Streamline'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M4.5 20.5h15a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5V21a.5.5 0 0 1 .5-.5ZM22.718 3c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77v13.436c0 .446-.046.607-.134.77a.909.909 0 0 1-.378.378c-.163.088-.324.134-.77.134H1.282c-.446 0-.607-.046-.77-.134a.909.909 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77V4.282c0-.446.046-.607.134-.77a.909.909 0 0 1 .378-.378C.675 3.046.836 3 1.282 3h21.436ZM22.5 4.5h-21l-.001 13H22.5v-13ZM9 7l7 3.85-7 3.85V7Z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Subscription'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
  >
    <path
      fill="#000"
      fill-rule="evenodd"
      d="M12 0c6.62 0 12 5.38 12 12s-5.38 12-12 12S0 18.62 0 12 5.38 0 12 0Zm2.826 4.537a8.21 8.21 0 0 0-6.416.244C6.35 5.735 4.8 7.394 4.044 9.486c-1.617 4.191.496 8.949 4.687 10.658l.24.094.132.04a.755.755 0 0 0 .213.03c.417.002.802-.256.92-.65.192-.495-.077-1.055-.593-1.254-3.308-1.255-4.994-4.962-3.767-8.272a6.45 6.45 0 0 1 3.337-3.594 6.363 6.363 0 0 1 4.904-.17l.263.105a6.428 6.428 0 0 1 3.208 2.951l.077.157-2.11-.03 3.293 5.941 3.5-5.81-2.514-.034-.036-.109a8.374 8.374 0 0 0-4.972-5.002Z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Threads'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clip-path="url(#a)">
      <path
        fill="currentColor"
        d="M11.72 24h-.006c-3.581-.024-6.334-1.205-8.184-3.509-1.644-2.052-2.494-4.905-2.523-8.481v-.017c.029-3.579.879-6.43 2.525-8.482C5.38 1.205 8.135.024 11.714 0h.014c2.746.02 5.042.725 6.826 2.098 1.677 1.29 2.858 3.13 3.508 5.467l-2.04.569c-1.104-3.96-3.897-5.984-8.304-6.015-2.908.022-5.11.936-6.54 2.717C3.842 6.504 3.15 8.914 3.124 12c.026 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.141 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.019.142c-.125-.742-.374-1.332-.749-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.845 0-1.992.232-2.721 1.32L7.269 7.847c.979-1.454 2.568-2.256 4.478-2.256h.043c3.195.02 5.098 1.975 5.288 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.85 1.81-4.095 2.628-7.277 2.65h-.007Zm1.004-11.69c-.242 0-.487.007-.74.021-1.835.103-2.98.946-2.915 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.817-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M1 0h21.072v24H1z" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-else-if="icon == 'Tick'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="tick-a"
        d="M23.85 4.15l-3.5-3.5a.5.5 0 00-.7 0L7.5 12.79 4.35 9.65a.5.5 0 00-.7 0l-3.5 3.5a.5.5 0 000 .7l7 7a.5.5 0 00.7 0l16-16a.5.5 0 000-.7"
      />
    </defs>
    <g fill="none" fill-rule="evenodd" transform="translate(0 2)">
      <mask id="tick-b" fill="#fff"><use xlink:href="#tick-a" /></mask>
      <use fill="#000" xlink:href="#tick-a" />
      <g fill="currentColor" mask="url(#tick-b)"><path d="M0-2h24v24H0z" /></g>
    </g>
  </svg>

  <svg
    v-else-if="icon == 'Tickets'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    transform="rotate(-45)"
    xlink:href="#tickets-a"
  >
    <path
      id="tickets-a"
      d="M23 10.137V7H1v3.147a2.12 2.12 0 011.983 2.114A2.13 2.13 0 011 14.384v3.169h22v-3.148a2.138 2.138 0 01-2.134-2.135c0-1.185.959-2.133 2.134-2.133zM8.783 16.97c0 .162-.183.29-.42.29-.226 0-.41-.128-.41-.29v-.982c0-.161.184-.29.41-.29.237 0 .42.129.42.29v.982zm0-2.081c0 .162-.183.291-.42.291-.226 0-.41-.13-.41-.291v-.982c0-.161.184-.29.41-.29.237 0 .42.129.42.29v.982zm0-2.08c0 .15-.183.28-.42.28-.226 0-.41-.13-.41-.28v-.991c0-.162.184-.292.41-.292.237 0 .42.13.42.292v.99zm0-2.09c0 .16-.183.29-.42.29-.226 0-.41-.13-.41-.29v-.983c0-.161.184-.29.41-.29.237 0 .42.129.42.29v.982zm0-2.082c0 .162-.183.291-.42.291-.226 0-.41-.13-.41-.291v-.98c0-.162.184-.292.41-.292.237 0 .42.13.42.291v.98z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Tiktok'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 121 138"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#tiktok-a"
  >
    <path
      id="tiktok-a"
      d="M116.635794,30.7319652 C102.225809,30.7319652 90.5162784,19.0201649 90.5162784,4.61396218 C90.5162784,2.38552042 88.7159758,0.589 86.4920726,0.589 L64.9640847,0.589 C62.7401815,0.589 60.939879,2.38552042 60.939879,4.61396218 L60.939879,92.8840076 C60.939879,101.348455 54.0488048,108.241042 45.584357,108.241042 C37.1199092,108.241042 30.2288351,101.348455 30.2288351,92.8840076 C30.2288351,84.4203162 37.1199092,77.5269728 45.584357,77.5269728 C47.8158245,77.5269728 49.6085628,75.7304523 49.6085628,73.502767 L49.6085628,51.9793177 C49.6085628,49.7508759 47.8158245,47.9543555 45.584357,47.9543555 C20.8188502,47.9543555 0.66,68.1132057 0.66,92.8840076 C0.66,117.654809 20.8188502,137.81366 45.584357,137.81366 C70.3574281,137.81366 90.5162784,117.654809 90.5162784,92.8840076 L90.5162784,53.8098775 C98.5117398,58.0768971 107.407352,60.3053389 116.635794,60.3053389 C118.859697,60.3053389 120.66,58.5088185 120.66,56.2803767 L120.66,34.7569274 C120.66,32.5284856 118.859697,30.7319652 116.635794,30.7319652"
    />
  </svg>

  <svg
    v-else-if="icon == 'Twitter'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#twitter-a"
  >
    <path
      id="twitter-a"
      d="M24 4.54a9.832 9.832 0 01-2.827.775 4.944 4.944 0 002.164-2.722 9.925 9.925 0 01-3.128 1.195 4.924 4.924 0 00-8.39 4.489A13.978 13.978 0 011.672 3.132a4.886 4.886 0 00-.666 2.475 4.92 4.92 0 002.19 4.097 4.924 4.924 0 01-2.23-.618v.062a4.928 4.928 0 003.949 4.827 4.987 4.987 0 01-1.298.173c-.318 0-.625-.032-.926-.092a4.926 4.926 0 004.598 3.42 9.878 9.878 0 01-6.115 2.104c-.397 0-.789-.024-1.174-.068a13.917 13.917 0 007.547 2.216c9.056 0 14.007-7.502 14.007-14.008l-.017-.637A9.832 9.832 0 0024 4.539z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Video'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#video-a"
  >
    <path
      id="video-a"
      d="M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm0 1.45C6.183 1.45 1.45 6.184 1.45 12c0 5.817 4.733 10.55 10.55 10.55 5.817 0 10.55-4.733 10.55-10.55 0-5.817-4.733-10.55-10.55-10.55zM9 7l7.877 4.583L9 16.166V7z"
    />
  </svg>

  <svg
    v-else-if="icon === 'Video Camera'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="videoCamera-a"
        d="M15.708 6c.935 0 1.718.758 1.693 1.693v10.256c0 .935-.758 1.693-1.693 1.693H2.193C1.258 19.642.5 18.884.5 17.95V7.693C.5 6.758 1.258 6 2.193 6zm6.655 2.274c.53-.228 1.137.151 1.137.732v7.63c0 .58-.606.985-1.137.732l-3.688-1.692c-.303-.127-.48-.43-.48-.733V10.7c0-.303.202-.606.48-.733zM7.7 9.865c-.354-.252-.859 0-.859.455v5.002c0 .43.48.707.859.455l3.739-2.501c.328-.202.328-.708 0-.91z"
      />
    </defs>
    <use fill="currentColor" xlink:href="#videoCamera-a" fill-rule="evenodd" />
  </svg>

  <svg
    v-else-if="icon == 'Whistle'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    fill-rule="evenodd"
    xlink:href="#whistle-a"
  >
    <path
      id="whistle-a"
      d="M20.062 12.699a5.129 5.129 0 00-1.76-7.05c-2.416-1.457-5.59-.647-7.04 1.797-1.439 2.426-.642 5.658 1.744 7.073 2.401 1.423 5.612.595 7.056-1.82M20.37.739l1.44.879-1.072 1.756c1.461 1.343 2.625 2.843 3.04 4.803.694 3.277-.254 6.075-2.738 8.225-2.435 2.107-5.31 2.63-8.333 1.393-1.122-.46-1.812-.364-2.652.558-1.523 1.672-3.214 3.19-4.835 4.772L0 19.937c.045-.132.068-.277.139-.393C2.975 14.893 5.8 10.234 8.663 5.6c1.196-1.936 2.95-3.136 5.171-3.665 1.874-.447 3.668-.096 5.466.557L20.37.738z"
    />
  </svg>

  <svg
    v-else-if="icon == 'Weibo'"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    fill-rule="evenodd"
    viewBox="0 0 24 24"
  >
    <path
      id="weibo"
      d="M11.753 8.227c1.436-.096 4.482-1.7 5.828-.134.593.69.366 1.927 0 2.881 1.673.915 3.682 1.37 3.35 4.087-.08.65-.475 1.52-.871 2.076-2.828 3.958-11.356 5.621-16.682 2.613C1.592 18.74-.256 17.264.03 14.323.275 11.79 1.977 9.83 3.647 8.16c1.593-1.594 3.274-2.842 5.56-3.416 2.48-.624 3.214 1.444 2.546 3.483zM9.34 10.505c-1.806.148-3.02.53-4.288 1.273-1.034.607-2.244 1.595-2.545 3.08-.677 3.343 2.958 4.914 5.627 5.092 3.084.207 6.171-.881 7.637-2.546.536-.607 1.074-1.533 1.071-2.611-.007-3.33-4.2-4.56-7.502-4.288zm3.483 3.952c1.428 4.314-6.009 6.32-7.368 2.613-.91-2.48 1.275-4.451 3.55-4.69 1.943-.203 3.39.788 3.818 2.077zm-5.091.805c-1.585.37-1.279 2.626.469 2.21 1.25-.297 1.418-2.652-.47-2.21zm1.675-.068c.303.525.999.148.938-.267-.073-.48-.944-.41-.938.267zm14.537-7.436c.103 1.336-.123 2.936-1.005 3.015-1.043.093-.936-.713-.791-1.527l.041-.232c.041-.231.077-.455.08-.653.053-2.767-2.309-4.689-4.622-4.689-.656 0-2.178.444-1.944-.938.106-.61.622-.6 1.14-.67 3.89-.519 6.827 2.158 7.1 5.694zm-3.283 0c.14 1.02-.152 1.904-.737 1.943-.976.065-.61-.668-.67-1.54-.037-.538-.482-1.158-.871-1.34-.763-.358-1.943.26-1.943-.804 0-.79.685-.708 1.073-.737 1.696-.13 2.95 1.04 3.148 2.478z"
    />
  </svg>

  <svg
    v-else-if="icon == 'X'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clip-path="url(#a)">
      <path
        fill="#000"
        d="M13.969 10.157 22.707 0h-2.07l-7.588 8.82L6.99 0H0l9.164 13.336L0 23.988h2.07l8.013-9.314 6.4 9.314h6.989l-9.504-13.83h.001Zm-2.836 3.297-.929-1.328L2.817 1.559h3.18l5.962 8.528.929 1.328 7.75 11.085h-3.181l-6.324-9.046Z"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h23.472v24H0z" /></clipPath>
    </defs>
  </svg>

  <svg
    v-else-if="icon == 'Youtube'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    fill="currentColor"
    xlink:href="#youtube"
  >
    <path
      id="youtube"
      d="M19.938 4.045H4.062A4.062 4.062 0 000 8.107v8.492a4.062 4.062 0 004.062 4.062h15.876A4.062 4.062 0 0024 16.599V8.107a4.062 4.062 0 00-4.062-4.062zM13.015 14.2l-3.6 1.846V8.661l3.6 1.846 3.6 1.846-3.6 1.846z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconSelector",

  props: {
    icon: {
      validator: function (value) {
        // The value must match one of these strings
        return (
          [
            "",
            "Account",
            "Article",
            "Attendance",
            "Audio",
            "Audio 2",
            "Ball",
            "Basket",
            "Burger",
            "Calendar",
            "Calendar 2",
            "Camera",
            "Chevron Left",
            "Chevron Right",
            "Close",
            "Copy Link",
            "Country",
            "Delete",
            "Download",
            "Email",
            "Email Filled",
            "External Link",
            "Facebook",
            "Feed",
            "FullTime",
            "Group",
            "Hospitality",
            "Info",
            "Instagram",
            "Lineups",
            "Linkedin",
            "Live",
            "Match",
            "Microphone",
            "Notification",
            "Padlock",
            "Phone",
            // 'Play',
            "Player",
            "Plus",
            "Position",
            "Quiz",
            "Refine",
            "Refresh",
            "Scores",
            "Search",
            "Share",
            "Shirt",
            "SignIn",
            "Slot",
            "Snapchat",
            "Spotify",
            "Star",
            "Stats",
            "Streamline",
            "Subscription",
            "Threads",
            "Tick",
            "Tickets",
            "Tiktok",
            "Twitter",
            "Video",
            "Video Camera",
            "Weibo",
            "Whistle",
            "X",
            "Youtube",
          ].indexOf(value) !== -1
        );
      },
    },
  },

  data: () => ({
    shirtStyle: "plain",
  }),
};
</script>

<style lang="scss" scoped>
svg {
  height: 24px;
  width: 24px;
}
</style>
